class LayerAnnotation {
	

	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		this.currentAnnotation = false;
		this.currentAnnotationIdx = false;
		
	}

	
	json(){
		var points = this.scenario.annotations.slice(0);	
		LayerAnnotation.data = {
			"type":"FeatureCollection",
			"features":[]
		};
			
		LayerAnnotation.data.features = points.map(LayerAnnotation.itemToFeature);
		
		const l = {
			'images': [
				{
					'src': '/images/icons/annotation_marker.png',
					'name': 'annotationmarker'
				},
				{
					'src': '/images/icons/annotation_marker.png',
					'name': 'annotationmarker_hover'
				},
				{
					'src': '/images/icons/annotation_marker_on.png',
					'name': 'annotationmarker_on'
				}
			],
			'source': {
				'id': LayerAnnotation.sourceId,
				'type': 'geojson',
				'data': LayerAnnotation.data
			},
			'layer': [
				{
					'id': LayerAnnotation.layerId,
					'type': 'symbol',
					'source': LayerAnnotation.sourceId,
					'layout': {
						'icon-image':['case',
							['boolean', ['get', 'invisible'], false],'',
							['boolean', ['get', 'selected'], false],'annotationmarker_on',
							['boolean', ['get', 'hover'], false],'annotationmarker_hover',
							'annotationmarker'
						],
						'icon-size':['case',
							['boolean', ['get', 'invisible'], false],1,
							['boolean', ['get', 'selected'], false],1,
							['boolean', ['get', 'hover'], false],1.1,
							1
						],
						'icon-anchor' : 'bottom-left',
						'icon-allow-overlap' : true,

					},
				}
			]
		};
		return l;
	}
	
		
}
LayerAnnotation.itemToFeature = (f, idx) => {
	
	
	f.type = 'Feature';
	f.geometry = {
		coordinates:[
			f.lon,
			f.lat
		],
		"type" : "Point"
	}
	f.properties = {...f.properties};
	if(isNaN(f.id))
		f.properties.tempid = f.id;

	f.properties.idx = idx;
	f.properties.annotationid = f.id;
	f.properties.name=f.name ? f.name : 'Annotation '+f.sensorid;
	return f;
}
LayerAnnotation.layerId = 'annotations_layer';
LayerAnnotation.sourceId = 'annotations_source';


export default LayerAnnotation;